import { createSelector } from 'reselect';
import { subselect } from './root';
import { loadedDataSelector } from './loadedData';
import { isLeaderboardVisibleSelector } from './isLeaderboardVisible';

export const isVisibleSelector = createSelector(
  [loadedDataSelector, isLeaderboardVisibleSelector],
  (value, isLeaderboardVisible) => !!value || isLeaderboardVisible,
);

export const triviaIsVisibleSelector = subselect(isVisibleSelector);
